// removed by extract-text-webpack-plugin
module.exports = {"toggled":"_2qLL9VL6ux8TLTjoUXSMWD","title":"_3gfgG5Ob7PmkdTe0ss2j-X","chevron":"DpIulWXSIRpeslz2a243s","rotated":"aZOUggHYO_inPmvOYADw8","placeholder":"_1SAxnBB15vZv_3O6P1fxIW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/components/CollapseSection.mod.css
// module id = 1021
// module chunks = 0